export { default } from './TherigyInsights';
